import axios from 'axios'

import env from '@/../.env'

var myaxios = axios.create({
    baseURL: env.BASE_URL + env.API_URL
})

export default myaxios
